import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  // 上海 导出PDF文件
  getPDF({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/shanghaiPlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findExportUrlById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
      .get(`/shanghaiPlan/findExportUrlById`, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailForNewPlanByLastStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/shanghaiPlan/selectProgramInfoLast`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findUniversityQueryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/findUniversityQueryList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/save`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/selectSchemeList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectInitialSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/selectLastProgramList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/estimatePlan/findBasicConfigData`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
